import React from 'react'
import './../../assets/termsOfUse.css'

const TermsOfUsePage = () => {
 return (
  <div className='max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-lg rounded-lg font-sans'>
   <main className='terms-content'>
    <h1 className='title'>TERMS OF USE</h1>
    <p className='text-center italic text-gray-500 mb-8'>
     Last updated on: <strong>[31st Oct, 2025]</strong>
    </p>
    <br />
    <p>
     These Terms and Conditions (<strong>“Terms”</strong>)
     govern your access or use of the FarmRise One website
     available at [
     <a
      href='https://portal.farmriseone.com/'
      target='_blank'
      rel='noopener noreferrer'
      style={{color: 'blue', textDecoration: 'underline'}}
     >
      https://portal.farmriseone.com/
     </a>
     ] or mobile application [
     <a
      href='https://play.google.com/store/apps/details?id=com.farmrise.one&hl=en_IN'
      target='_blank'
      rel='noopener noreferrer'
      style={{color: 'blue', textDecoration: 'underline'}}
     >
      https://play.google.com/store/apps/details?id=com.farmrise.one&hl=en_IN
     </a>
     ] operated by Bayer (collectively, the
     <strong>“Platform”</strong>) and Services (defined
     below) made available on or through the Platform. The
     provision of the Platform and services on or through
     the Platform is referred to as{' '}
     <strong>“Services”</strong>.
    </p>

    <p>
     The Services are provided by Bayer CropScience Limited,
     a company established under the laws of India, having
     its registered office at Bayer House, Central Avenue,
     Hiranandani Estate, Thane (West) – 400607 and its
     affiliates{' '}
     <strong>(“Bayer”, “we”, “us” or “our”)</strong>. Please
     read these Terms carefully before accessing or using
     the Platform or Services. These Terms also include our
     privacy policy, available at [
     <a
      href='https://portal.farmriseone.com/privacy-policy'
      target='_blank'
      rel='noopener noreferrer'
      style={{color: 'blue', textDecoration: 'underline'}}
     >
      https://portal.farmriseone.com/privacy-policy
     </a>
     ] <strong>(“Privacy Policy”)</strong> and any other
     additional policies and terms issued by us from time to
     time. For the purposes of these Terms, a user of the
     Platform or Services is referred to as a{' '}
     <strong>“User”</strong> or <strong>“you”</strong>.
    </p>

    <p>
     This document is an electronic record in terms of the
     Information Technology Act, 2000{' '}
     <strong>(“IT Act”)</strong> and the rules thereunder as
     applicable, and the amended provisions pertaining to
     electronic records in various statutes as amended by
     the IT Act. This electronic record is generated by a
     computer system and does not require any physical or
     digital signatures.
    </p>

    <section className='no-counter'>
     <h2 className='section-header'>
      1. USER ACKNOWLEDGEMENT
     </h2>
     <p>
      Your access and use of the Platform and the Services
      constitute your agreement to be bound by these Terms,
      which establishes a contractual relationship between
      you and us. If you do not agree to these Terms, you
      may not access or use the Services or the Platform.
     </p>
    </section>

    <section>
     <h2 className='section-header'>2. ELIGIBILITY</h2>
     <p>
      You may use the Services if you are competent to
      contract, have not been previously suspended or
      removed by us from availing the Services, have not
      been disqualified from availing any Services, and are
      not barred or otherwise legally prohibited from
      accessing or using the Services.
     </p>
     <br />
     <p>
      If you represent an entity, organisation, or any other
      legal person, you confirm and represent that you are
      duly authorised to accept these Terms on behalf of and
      have the necessary power to bind such entity,
      organisation, or legal person to these Terms.
     </p>
    </section>

    <section>
     <h2 className='section-header'>3. SERVICES</h2>
     <p>
      The Platform is a digital marketplace that enables
      farmer producer organisations/companies{' '}
      <strong>(“FPOs”)</strong>, primary agricultural
      cooperative credit societies
      <strong>(“PACS”)</strong>, Better Life Farming Centres{' '}
      <strong>(“BLFCs”)</strong>, other analogous farmer
      producer collectives, and farmers to sell agricultural
      produce <strong>(“Produce”)</strong> to off takers
      and/or buyers (each, a <strong>“Buyer”</strong>), or
      such other services as may be determined by us at our
      sole discretion from time to time. The Platform may
      also enable third party service providers, including
      but not limited to our affiliates, payment gateway
      providers, banks and financial service providers,
      warehouse service providers and insurers
      (collectively,{' '}
      <strong>“Third Party Service Providers”</strong>) to
      provide additional services to FPOs, PACS, BLFCs, and
      Buyers through the Platform. Services include, but are
      not limited to, the facilitation of the sale and
      purchase of agricultural commodities and provision of
      inputs, outputs, access to financial services, and
      market linkage services among Users.
     </p>
     <br />
     <p>
      You understand and agree that these Terms govern your
      general use of the Platform and are in addition to,
      and not in derogation of, any specific terms and
      conditions applicable to individual Services made
      available to you through the Platform. Such additional
      terms and conditions or obligations may be outlined in
      service-specific terms made available to you on the
      Platform or any agreement separately entered into
      between you and us. In the event of any inconsistency
      between these Terms and such specific terms, the
      latter shall prevail to the extent of such
      inconsistency, unless expressly stated otherwise.
     </p>
     <br />
     <p>
      From time to time, we may make available certain
      promotional schemes, limited-period offers, or other
      campaigns (collectively, <strong>“Offers”</strong>) in
      connection with the Services at our discretion. Unless
      otherwise expressly stated, such Offers are subject to
      additional terms and conditions specific to each Offer
      <strong>(“Offer Terms”)</strong>. Users are advised to
      carefully read the applicable Offer Terms before
      participating in any such Offer. In the event of any
      conflict between these Terms and the applicable Offer
      Terms, the Offer Terms shall prevail to the extent of
      such conflict. You acknowledge that we reserve the
      right to withdraw, modify, or discontinue any Offer at
      our discretion, without prior notice and without any
      liability.
     </p>
    </section>

    <section>
     <h2 className='section-header'>4. PROFILE CREATION</h2>
     <p>
      To access certain features of the Platform or the
      Services, you are required to create a profile
      <strong>(“Account”)</strong> on the Platform. To
      create an Account, you must provide us with your email
      address, phone number, gender, or such other
      information which we require to authenticate your
      identity. If you choose to create an Account, you
      agree to provide and maintain true, accurate, and
      complete information about yourself. A failure to do
      so shall constitute a breach of the Terms, which may
      result in immediate termination or suspension of your
      Account.
     </p>
     <br />
     <p>
      You are solely responsible for maintaining the
      confidentiality of the Account details and for any
      activity that occurs through your Account. You agree
      to immediately notify us of any actual or suspected
      unauthorised use of your Account or any other breach
      of security. We will not be liable for any losses or
      damages that may arise from your failure to comply
      with the above-mentioned provisions or your failure to
      ensure the confidentiality of your Account or
      password.
     </p>
     <br />
     <p>
      We reserve the right to revoke your access to the
      Account, Platform, and/or Services if, in our
      reasonable opinion, you are in breach of any provision
      of the Terms or the applicable law, in the event of
      any actual or suspected unauthorised access to your
      Account, or if your Account remains inactive for a
      period exceeding 1 (One) calendar year.
     </p>
     <br />
     <p>
      You agree and acknowledge that you may be required to
      provide us with access to certain information to
      enable us to provide the Services. Where this
      information includes personal information, our access
      to and use of such information shall be in accordance
      with the Privacy Policy. You may have the right to
      revoke access to your data; however, you acknowledge
      that this may impair your use of the Services.
     </p>
    </section>

    <section>
     <h2 className='section-header'>5. VERIFICATION</h2>
     <p>
      You may be required to undertake certain additional
      processes with us in order to avail the Services. In
      this regard, we may, under the instructions of our
      Third Party Service Providers and on their behalf,
      require you to upload documents and information that
      may be necessary for the Third Party Service Providers
      to ascertain your eligibility to avail the Third Party
      Services (defined below).
     </p>
     <br />
     <p>
      Any processing of personal information that we
      undertake shall be in accordance with our Privacy
      Policy. Further, in the event any additional
      information, data, or documentation is required by us
      or the Third Party Service Providers (collectively,
      <strong>“Additional Information”</strong>), you agree
      to share such Additional Information promptly upon
      request, and further authorise us and/or our Third
      Party Service Providers to process such Additional
      Information in connection with the Services, the Third
      Party Services and your use of the Platform.
     </p>
     <br />
     <p>
      If the Additional Information provided by you, in our
      sole discretion, is unreliable or appears to be
      fraudulent or deficient, we reserve the right to not
      provide you the Services or revoke your access to the
      Platform, as the case may be.
     </p>
    </section>

    <section>
     <h2 className='section-header'>6. FEES</h2>
     <p>
      You may be charged a fee for the specific Service
      which shall be set forth on the Platform{' '}
      <strong>(“Fees”)</strong>. We reserve the right to
      charge such Fees as we may determine, in our sole
      discretion from time to time, to provide you with the
      Services chosen by you. You agree to pay any Fees in
      accordance with the timelines prescribed by us from
      time to time.
     </p>
     <br />
     <p>
      Each User agrees and acknowledges that we reserve the
      right to introduce or change any Fees, charges or
      commissions for the use of the Platform or the
      Services, in any manner we deem appropriate, and in
      the event a User uses or continues to use the Platform
      or the Services on or after the date such Fees,
      charges or commission are introduced, such User shall
      be deemed to have agreed to accept the imposition of
      such Fees, charges or commission, and shall be
      responsible to pay to us such amounts for the use of
      the Platform or Services.
     </p>
     <br />
     <p>
      Changes to any Fees, charges or commissions shall be
      notified through the Platform and shall become
      effective from the date of such notification.
     </p>
     <br />
     <p>
      Each User agrees that it shall be solely responsible
      for payment of any applicable governmental or
      statutory duties or taxes in relation to the marketing
      and sale of the Produce or any payments to us or any
      other transactions undertaken pursuant to their
      interactions on the Platform.
     </p>
     <br />
     <p>
      Users agree that we shall, at all times, have the
      right to set off or counterclaim any payments due to,
      or from, any User in one transaction, against any
      payments due to, or from, the User in other or
      previous transactions. Further, we shall have the
      right to withhold any payment with respect to a sale
      or a transaction if we, at our sole discretion,
      suspect that such a sale or a transaction is
      suspicious in nature.
     </p>
    </section>

    <section className='no-counter'>
     <h2 className='section-header'>
      7. PAYMENT FOR TRANSACTIONS CONDUCTED OVER THE
      PLATFORM
     </h2>
     <p>
      The Platform may enable different payment methods to
      facilitate transactions between Users. You understand
      and agree that any and all contracts of sale and/or
      purchase of any goods or services (including title,
      pricing, payment methods, terms and warranties) that
      are availed through the Platform are solely between
      the respective contracting parties. The settlement of
      any monies related to such sale and/or purchase shall
      be enabled by the respective Third Party Service
      Provider.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      8. THIRD PARTY SERVICES
     </h2>
     <p>
      The Services may include services, content, documents,
      and information owned by, licensed to, or otherwise
      made available by Third Party Service Providers
      <strong>(“Third-Party Services”)</strong> or contain
      links to Third-Party Services as necessary to enable
      such Third Party Service Providers to provide
      Third-Party Services that are complementary to the
      Services. You understand and acknowledge that Third
      Party Services are the responsibility of the Third
      Party Service Providers that created or provided it,
      and acknowledge that use of such Third Party Services
      is solely at your own risk.
     </p>
     <br />
     <p>
      We make no representations and exclude all warranties
      and liabilities, express or implied or arising in law,
      arising out of or pertaining to such Third Party
      Services, including their accuracy or completeness.
      Should you avail a Third Party Service, you shall be
      governed and bound by the terms and conditions,
      privacy policy and any other applicable terms of the
      Third Party Service Provider providing the applicable
      Third Party Service. You acknowledge that we are not
      liable for any issue in connection with a Third Party
      Service or a Third Party Service Provider.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      9. ADDITIONAL TERMS FOR THIRD PARTY SERVICE PROVIDERS
     </h2>
     <p>
      You agree that all interactions with Users for the
      provision of Third Party Services, including but not
      limited to credit eligibility assessment,
      documentation, due diligence, and customer
      communication, shall be conducted directly by you or
      your Representatives with the User independently
      outside the Platform. You acknowledge that neither the
      Platform nor we act as your agent or intermediary for
      the provision of any Third Party Service to the Users.
     </p>
     <br />
     <p>
      You are solely responsible for entering into binding
      agreements with Users and for making all disclosures,
      obtaining consents, and satisfying all regulatory
      obligations as required under applicable law.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      10. GENERAL RESPONSIBILITIES
     </h2>
     <p>You represent and warrant that:</p>
     <ol className='alpha-list' type='a'>
      <li>
       all information that you provide on the Platform or
       in relation to the Services or through the Account or
       any Additional Information you provide is complete,
       true, and correct on the date of agreeing to these
       Terms and shall continue to be complete, true, and
       correct while you avail the Services, access the
       Platform or otherwise have an Account on the
       Platform. Should any information that you provide
       change during the existence of these Terms, you
       undertake to immediately bring such change to our
       notice. We do not accept any responsibility or
       liability for any loss or damage that you may suffer
       or incur if any information, documentation, material,
       or data provided to avail the Services is incorrect,
       incomplete, inaccurate, or misleading, or if you fail
       to disclose any material fact or notify us of any
       change to the same.
      </li>
      <br />
      <li>
       you possess all the necessary licences, concessions,
       grants, authorisations, registrations and permits
       required for availing the Services and/or access to
       the Platform.
      </li>
      <br />
      <li>
       your use and access of the Platform and/or the
       Services shall not violate any applicable law.
      </li>
      <br />
      <li>
       you do not and will not impersonate any person or
       entity, or falsely state or otherwise misrepresent
       such person’s or entity’s identity.
      </li>
      <br />
      <li>
       your use and access of the Platform and/or Services
       shall not violate Bayer’s Code of Conduct as
       available at [
       <a
        href='https://portal.farmriseone.com/code-of-conduct'
        target='_blank'
        rel='noopener noreferrer'
        style={{color: 'blue', textDecoration: 'underline'}}
       >
        https://portal.farmriseone.com/code-of-conduct
       </a>
       ].
      </li>
      <br />
      <li>
       you have obtained the requisite consent as may be
       required under applicable law from a third party
       prior to sharing any information of such third party
       with us or any other third party.
      </li>
     </ol>
     <p>
      You shall extend all cooperation to us in our defence
      of any proceedings that may be initiated against us
      due to breach of your obligations or covenants under
      these Terms.
     </p>
     <br />
     <p>
      You shall not use the Services in any manner except as
      expressly permitted in these Terms and in accordance
      with applicable law. Without limiting the generality
      of the preceding sentence, you may not:
     </p>
     <ol className='alpha-list' type='a'>
      <li>
       infringe, violate or misappropriate any proprietary
       rights, including but not limited to copyrights,
       patents, trademarks, or trade secrets, of Bayer or
       any other party;
      </li>
      <br />
      <li>
       except as may be provided hereunder, sell, lease,
       sublicense, copy, display, market, distribute,
       modify, publish, reproduce, store, transmit, post,
       translate, create any derivative works from, or
       license the Services;
      </li>
      <br />
      <li>
       use the Services to transmit any data or send or
       upload any material that contains viruses, trojan
       horses, worms, timebombs, keystroke loggers, spyware,
       adware, or any other harmful programmes or similar
       computer code designed to adversely affect the
       operation of any computer software or hardware;
      </li>
      <br />
      <li>
       use any robot, spider, other automated device, or
       manual process to monitor or copy the Platform or
       Services or any portion thereof;
      </li>
      <br />
      <li>
       engage in the systematic retrieval of content from
       the Platform to create or compile, directly or
       indirectly, a collection, compilation, database or
       directory;
      </li>
      <br />
      <li>
       use the Services in any unlawful manner, for
       fraudulent or malicious activities, or in any manner
       inconsistent with these Terms;
      </li>
      <br />
      <li>
       use the Platform for any purpose other than to avail
       the Services made available by the Platform;
      </li>
      <br />
      <li>
       reverse engineer, decompile or disassemble any third
       party’s intellectual property, or otherwise attempt
       to obtain, directly or indirectly, source code or
       attempt to discover any underlying proprietary
       methods or algorithms;
      </li>
      <br />
      <li>
       upload or transmit any information or content that is
       obscene, pornographic, pedophilic, immoral, invasive
       of another’s privacy, or is relating to or
       encouraging money laundering or gambling, an online
       game that causes user harm, or promoting enmity
       between different groups on the grounds of religion
       or caste with the intent to incite violence;
      </li>
      <br />
      <li>
       act in an abusive or threatening manner or use
       abusive or threatening language on or through the
       Platform;
      </li>
      <br />
      <li>
       upload or transmit information or content that is
       harmful to children or that impersonates another
       person, or deceive or mislead any addressee about the
       origin of a message, or knowingly and intentionally
       communicates any misinformation or information which
       is patently false and untrue or misleading in nature
       or, in respect of any business of the Indian
       government, is identified as fake or false or
       misleading by the fact check unit of the Indian
       government;
      </li>
      <br />
      <li>
       threaten the unity, integrity, defence, security, or
       sovereignty of India, friendly relations with foreign
       states, or public order, or cause incitement to the
       commission of any cognizable offence, or prevent
       investigation of any offence, or insult another
       nation in any manner; and
      </li>
      <br />
      <li>
       take any action that may adversely affect the
       Services or Platform.
      </li>
     </ol>
     <p>
      Each User irrevocably and unconditionally agrees that
      any contract entered into between Users, through or
      facilitated by the Platform, in violation of the
      Terms, shall be void and any delivery or payment made
      in furtherance thereof shall be deemed to be invalid.
     </p>
     <br />
     <p>
      We shall have the right to inspect and audit any Users
      or any other third-party engaged by such Users,
      including their records and place of business, through
      us or through our approved third-party testing
      agencies. Cost of such audit shall solely be borne by
      us unless such audit reflects any discrepancy in
      accounts or non-compliance with these Terms, in which
      case the cost of such audit shall be borne by _ the
      respective User.
     </p>
     <br />
     <p>
      Each User shall ensure that any personnel of the User
      or any third party acting under the instructions of
      the User <strong>(“Representative”)</strong> who has
      access to the Services and any personal data in
      connection with the Services is granted access only on
      a need-to-know basis and is subject to a duly
      enforceable contractual or statutory confidentiality
      obligation that is at least as stringent as the
      confidentiality obligations specified under these
      Terms.
     </p>
     <br />
     <p>
      Each User shall ensure that it undertakes appropriate
      measures to prevent unauthorised access to its Account
      and the Platform.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      11. OUR INTELLECTUAL PROPERTY
     </h2>
     <p>
      All rights, title, and interest in and to the Platform
      and Services, including all intellectual property
      rights arising out of the Platform and Services, are
      owned by or otherwise licensed to us. Subject to
      compliance with these Terms, we grant you a personal,
      non-exclusive, non-transferable, non-sub licensable,
      royalty-free, revocable, and limited licence to use
      the Platform in accordance with these Terms and
      instructions issued by us from time to time.
     </p>
     <br />
     <p>
      We may request you to submit suggestions and other
      feedback, including bug reports, relating to the
      Services and Platform from time to time{' '}
      <strong>(“Feedback”)</strong>. We may freely use,
      copy, disclose, publish, display, distribute, and
      exploit the Feedback we receive from you, without any
      payment of royalty, acknowledgement, prior consent, or
      any other form of restriction arising out of your
      intellectual property rights in such Feedback. You
      hereby waive any rights you may have that arise out of
      such Feedback and agree to execute such documentation
      as we may request to give effect to our rights under
      this Clause.
     </p>
     <br />
     <p>
      Except as stated in these Terms, nothing in these
      Terms should be construed as conferring any right in
      or license to our or any third-party’s intellectual
      property rights.
     </p>
     <br />
     <p>
      Any infringement, violation or misappropriation of our
      intellectual property by the User that is likely to
      have an adverse impact on our or any of our partners’
      brand, standing or reputation shall result in
      immediate termination or suspension of Services as
      determined by us in our sole discretion.
     </p>
    </section>

    <section className='no-counter'>
     <h2 className='section-header'>
      12. REGULATORY CHANGES
     </h2>
     <p>
      You acknowledge and agree that we may have to modify
      the Services and/or the Platform to comply with the
      applicable laws. As a result of this, you may be
      unable to access or use all or any part of the
      Services and/ or Platform. We shall not be liable to
      you for such inability to use the Services and/ or
      Platform pursuant to our compliance with the
      applicable laws.
     </p>
    </section>

    <section className='no-counter'>
     <h2 className='section-header'>13. TERM</h2>
     <p>
      These Terms shall remain in effect unless terminated
      in accordance with the terms hereunder.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      14. SUSPENSION, WITHDRAWAL OR TERMINATION OF ACCESS TO
      PLATFORM OR USE OF SERVICES
     </h2>
     <p>
      We do not guarantee that our Platform, or any content
      on it, or our Services will always be available or
      uninterrupted. We may revoke your access, suspend or
      withdraw or restrict the availability of all or any
      part of our Platform or Services for business, legal
      and operational reasons with immediate effect. We
      shall not be liable for any such revocation,
      suspension, withdrawal or discontinuation of the
      Services or the Platform.
     </p>
     <br />
     <p>
      Notwithstanding anything to the contrary in these
      Terms, any other terms, or any other communication
      between you and us, we may terminate your use of the
      Platform and your access to the Services at any time
      with or without notice, and for or without any reason,
      including non-compliance with applicable laws or a
      breach of any provision under these Terms.
     </p>
     <br />
     <p>
      Upon termination: (a) the Services and Platform will
      “time-out”; (b) you shall not be eligible to avail any
      features of the Services and Platform; and (c) these
      Terms and any licence granted herein shall terminate,
      except for those clauses that expressly or are
      intended to survive termination or expiry.
     </p>
     <br />
     <p>
      In case you do not wish to continue using our
      Services, and/or wish to deactivate your account,
      and/or unsubscribe from the mailing lists, you may do
      so by contacting us at{' '}
      <a href='mailto:info@farmriseone.com'>
       info@farmriseone.com
      </a>
      .
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      15. DISCLAIMERS AND WARRANTIES
     </h2>
     <p>
      To the fullest extent permissible under the applicable
      law, we disclaim all warranties, statutory, express or
      implied, including, but not limited to, implied
      warranties of merchantability, fitness for a
      particular purpose, satisfactory quality, accuracy,
      title and non-infringement, merchantability,
      compatibility, applicability, usability,
      appropriateness, and any warranty that may arise out
      of course of performance, course of dealing, or usage
      of trade. No advice or information, whether oral or
      written, obtained by you through the Platform or your
      use of the Services will constitute or create any
      representation or warranty not expressly stated
      herein.
     </p>
     <br />
     <p>
      You acknowledge and agree that the use of the Services
      and your access to the Platform is at your sole risk.
      To the fullest extent permitted under applicable law,
      the Platform, including any data, information, Third
      Party Services, reference sites, Services, or software
      made available through the Platform, is provided on an
      “as is” and “as available” basis and without
      warranties or representations of any kind, either
      express or implied. Neither we nor any of the
      Third-Party Service Providers warrant that the data,
      software, functions, or any other information offered
      on or through the Platform will be uninterrupted or
      free of errors, viruses or other harmful components or
      warrant that any of the foregoing will be corrected.
     </p>
     <br />
     <p>
      You shall be solely responsible for the activities
      that may take place through your Account, and you
      agree to use, access, and enter the Platform at your
      sole risk.
     </p>
     <br />
     <p>
      You understand that we shall in no manner be held
      liable for any unauthorised use of the Service or the
      Platform through your Account due to unauthorised
      access, including but not limited to hacking and
      security breaches.
     </p>
     <br />
     <p>
      You hereby accept full responsibility for any
      consequences that may arise from your use of the
      Services and the Platform, and expressly agree and
      acknowledge that we shall have absolutely no liability
      in connection with your use of the Services and the
      Platform including but not limited to quality of
      produce, rates negotiated between the transacting
      parties, delivery of the produce, and payments on or
      through the Platform.
     </p>
     <br />
     <p>
      To the fullest extent permissible by law, we and our
      related parties, each disclaim all liability to you
      for any loss or damage arising out of or due to:
     </p>
     <ol className='alpha-list' type='a'>
      <li>
       your use of, inability to use, or availability or
       unavailability of the Services or Platform, including
       any Third Party Services;
      </li>
      <br />
      <li>
       the occurrence or existence of any defect,
       interruption, or delays in the operation or
       transmission of information to, from, or through the
       Services, communications failure, theft, destruction
       or unauthorised access to our records, programmes,
       services, server, or other infrastructure relating to
       the Services or the Platform;
      </li>
      <br />
      <li>
       the failure of the Services or Platform to remain
       operational for any period of time; or
      </li>
      <br />
      <li>
       the collection or processing of your personal
       information by us.
      </li>
     </ol>
     <p>
      You also agree and acknowledge that there can be
      disruption in communication due to factors outside our
      control, including but not limited to your device
      being switched off, incorrect email address, and
      network interruptions. You agree not to hold us liable
      for non-delivery of any alert or any loss suffered by
      you due to any delay, distortion or failure of
      communication.
     </p>
     <br />
     <p>
      You further agree and acknowledge that any Offers
      provided by us may vary from user to user.
     </p>
    </section>

    <section className='no-counter'>
     <h2 className='section-header'>
      16. LIMITATION OF LIABILITY
     </h2>
     <p>
      In no event shall Bayer or its related parties, be
      liable to you or any third party for any special,
      indirect, incidental, consequential, punitive,
      reliance, or exemplary damages (including without
      limitation lost business opportunities, lost revenues,
      or loss of anticipated profits or any other pecuniary
      or non-pecuniary loss or damage of any nature
      whatsoever, including but not limited to abuse or
      breach of data), even if Bayer or an authorised
      representative have been advised of the possibility of
      such damages, arising out of or relating to: (a) these
      Terms; (b) the Services; (c) your use or inability to
      use the Services; or (d) any other interactions with
      another User in connection with the Services.
      Notwithstanding any provision to the contrary, the
      maximum aggregate liability of Bayer or its related
      parties for any and all claims arising out of the use
      or access of the Platform and/or Services in the
      aggregate will be limited to INR 10,000 (Rupees Ten
      Thousand). These limitations will also apply with
      respect to damages incurred by reason of any products
      or services sold or provided to you by third parties
      other than Bayer and received by you through or
      advertised on the Platform or received by you through
      any links provided on the Platform. This paragraph
      sets forth the entire liability of Bayer and your
      exclusive remedy with respect to the Services.
     </p>
    </section>

    <section>
     <h2 className='section-header'>17. INDEMNITY</h2>
     <p>
      You shall indemnify, defend or settle at our option,
      and hold us, our parent companies, subsidiaries, and
      their officers, associates, successors, assigns,
      licensors, employees, directors, agents, and
      representatives, harmless from and against any claim,
      demand, lawsuits, judicial proceeding, losses,
      liabilities, damages and costs (including, without
      limitation, from all damages, liabilities,
      settlements, costs and attorneys’ fees) due to or
      arising from or relating to:
     </p>
     <ol className='alpha-list' type='a'>
      <li>
       acts, commissions or omissions, errors,
       misrepresentations, misconduct, negligence, fraud,
       forgery, dishonesty, violation attributable to you
       and/or your personnel/agents/Representatives, or any
       third party who may use your Account;
      </li>
      <br />
      <li>your access to the Platform and the Services;</li>
      <li>
       your use of the Platform and the Services in
       violation of these Terms;
      </li>
      <br />
      <li>contravention of any applicable law;</li>
      <li>any claim from any governmental authority;</li>
      <li>
       any third party as a result of any action or inaction
       on your part, including but not limited to
       infringement of intellectual property rights;
      </li>
      <br />
      <li>
       unauthorised use of your Account as a result of your
       failure in keeping the account information secure,
       absolute, correct and confidential; and
      </li>
      <br />
      <li>
       service deficiency, inaccurate Produce availability
       or requirement details that are displayed on the
       Platform due to any negligence or default on your
       part.
      </li>
     </ol>
     <p>
      For the avoidance of doubt, it is clarified that the
      right to indemnification in connection with any of the
      aforesaid causes of action is independent and in
      addition to other rights and remedies as may be
      available to us at law or in equity.
     </p>
     <br />
     <p>
      It is further clarified that the rights and
      obligations under this clause shall survive a User’s
      cessation of the use of the Platform or the Services.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      18. JURISDICTION, GOVERNING LAWS, AND DISPUTE
      RESOLUTION
     </h2>
     <p>
      These Terms shall be governed by and construed and
      enforced in accordance with the laws of India. Subject
      to Clause 18.2, courts in Mumbai shall have exclusive
      jurisdiction over all issues arising out of these
      Terms or the use of the Services.
     </p>
     <br />
     <p>
      Any controversies, conflicts, disputes, or differences
      arising out of these Terms shall be resolved by
      arbitration in Mumbai in accordance with the Rules of
      Arbitration and Conciliation of the Bombay Chamber of
      Commerce and Industry, Mumbai. The language of the
      arbitration shall be English. The parties to the
      arbitration shall keep the arbitration confidential
      and not disclose to any person, other than on a
      need-to-know basis or to legal advisors and unless
      required to do so by law. The decision of the
      arbitrator shall be final and binding on all the
      parties hereto. Each party to the arbitration shall
      bear its own costs with respect to any dispute.
     </p>
    </section>

    <section>
     <h2 className='section-header'>
      19. MISCELLANEOUS PROVISIONS
     </h2>
     <p>
      <strong>Severability:</strong> If any provision of
      these Terms is determined by any court or other
      competent authority to be unlawful or unenforceable,
      the other provisions of these Terms will continue to
      be in effect. If any unlawful or unenforceable
      provision would be lawful or enforceable if part of it
      were deleted, that part will be deemed to be deleted,
      and the rest of the provision will continue to be in
      effect (unless that would contradict the clear
      intention of the clause, in which case the entirety of
      the relevant provision will be deemed to be deleted).
     </p>
     <br />
     <p>
      <strong>Assignment:</strong> You shall not licence,
      sell, transfer or assign your rights, obligations, or
      covenants under these Terms in any manner without our
      prior written consent. We may grant or withhold this
      consent in our sole discretion and subject to any
      conditions deemed appropriate. We may assign our
      rights to any of our affiliates, subsidiaries, or
      parent companies, or to any successor in interest of
      any business associated with the Services without any
      prior notice to you.
     </p>
     <br />
     <p>
      <strong>Notices:</strong> All notices, requests,
      demands, and determinations for us under these Terms
      (other than routine operational communications) shall
      be sent to{' '}
      <a href='mailto:info@farmriseone.com'>
       info@farmriseone.com
      </a>
      .
     </p>
     <br />
     <p>
      <strong>Third Party Rights:</strong> No third party
      shall have any rights to enforce any Terms contained
      herein.
     </p>
     <br />
     <p>
      <strong>Force Majeure:</strong> You agree that we
      shall not be liable for any breach of these Terms if
      such breach is caused by an event that is
      unforeseeable and beyond our reasonable control (such
      as, depending on the circumstances, unavailability of
      any communication system, breach or virus in our
      system, sabotage, fire, flood, explosion, acts of God,
      civil commotion, strikes or industrial _ action of any
      kind, riots, insurrection, war, acts of government,
      unauthorised access to computer data and storage
      devices, computer crashes and regulatory or government
      actions (“Force Majeure Event”). In such
      circumstances, we will be entitled to a reasonable
      extension of time to perform our obligations and shall
      take commercially reasonable methods to inform you of
      the Force Majeure Event and use all reasonable
      endeavours to mitigate the effects of the Force
      Majeure Event.
     </p>
     <br />
     <p>
      <strong>Relationship between Parties:</strong> The
      relationship between Bayer and each User is on a
      principal to principal basis. Nothing in these Terms
      shall be deemed to constitute any person a partner,
      joint venture agent or legal representative of any
      other, or to create any fiduciary, employer-employee
      relationship between any such persons.
     </p>
     <br />
     <p>
      <strong>Publicity:</strong> Except as otherwise
      expressly provided in these Terms, no User shall issue
      any press release, blog, media outreach, public
      announcement, disclosure, statement or response,
      advertisement, or any other form of publicity relating
      to or in S connection with the Platform or Services or
      the subject matter thereof without first obtaining our
      prior written consent.
     </p>
     <br />
     <p>
      <strong>Translations:</strong> We may provide you with
      translated versions of these Terms solely to assist
      you with understanding these Terms in greater detail.
      The English version of these Terms shall be
      controlling in all respects. In the event of any
      inconsistency between the English version of these
      Terms and any translated version, the terms of the
      English version shall prevail.
     </p>
     <br />
     <p>
      <strong>Survival:</strong> Clause 6 (Fees), Clause 10
      (General Responsibilities), Clause 11 (Our
      Intellectual Property), Clause 14.3, Clause 15
      (Disclaimer and Warranties), Clause 16 (Limitation of
      Liability), Clause 17 (Indemnity), Clause 18
      (Jurisdiction, Governing Laws, and Dispute
      Resolution), Clause 19 (Miscellaneous Provisions)
      shall survive the termination of this Agreement.
      Notwithstanding the foregoing, the provisions of this
      Agreement which by their nature are intended to
      survive the termination of this Agreement shall
      survive the termination of this Agreement.
     </p>
     <br />
     <p>
      <strong>Correspondences:</strong> You agree to receive
      communications from us regarding (a) information
      relating to transactions undertaken on or through the
      Platform; (b) requests for payments; (c) information
      about us, the Services; and (d) any other matter in
      relation to the Services.
     </p>
     <br />
     <p>
      <strong>
       Changes to the Terms and the Platform:
      </strong>{' '}
      We reserve the right at any time to modify these Terms
      as well as modify the Services or the Platform at any
      time. Such modifications and additional terms and
      conditions will be effective immediately. We reserve
      the right to suspend or withdraw, or restrict the
      availability of all or any part of the Platform or the
      Services for business and operational reasons.
     </p>
    </section>

    <section className='no-counter'>
     <h2 className='section-header'>
      20. GRIEVANCE REDRESSAL MECHANISM
     </h2>
     <p>
      In order to address any questions or grievances that
      you may have regarding the use of the Services, please
      contact our grievance officers at:
     </p>
     <br />
     <p>
      Name: Smitha
      <br />
      Address: Bayer House
      <br />
      Central Avenue, Hiranandani Estate
      <br />
      Thane (West) – 400 607
      <br />
      Maharashtra, India
      <br />
      Email Address:{' '}
      <a href='mailto:smitha.murthy@bayer.com'>
       smitha.murthy@bayer.com
      </a>
     </p>
    </section>
   </main>
  </div>
 )
}

export default function TermsOfUseWrapper() {
 return (
  <>
   <TermsOfUsePage />
  </>
 )
}
